module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "product-item",
    on: {
      "click": function($event) {
        return _vm.goProductDetail(_vm.productVal.id)
      }
    }
  }, [_c('div', {
    staticClass: "product-detail"
  }, [_c('div', {
    staticClass: "product-left"
  }, [_c('img', {
    attrs: {
      "src": _vm.productVal.app_logo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-right"
  }, [_c('p', {
    staticClass: "right-title"
  }, [_vm._v(_vm._s(_vm.productVal.name))]), _vm._v(" "), _c('div', {
    staticClass: "right-attention"
  }, [_c('el-rate', {
    staticClass: "star-rate",
    attrs: {
      "disabled": true,
      "void-icon-class": "el-icon-star-on",
      "disabled-void-color": "#c4c6cc",
      "colors": ['#fe9c00', '#fe9c00', '#fe9c00']
    },
    model: {
      value: (_vm.productVal.star),
      callback: function($$v) {
        _vm.$set(_vm.productVal, "star", $$v)
      },
      expression: "productVal.star"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleCollect(_vm.productVal)
      }
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.productVal.is_collected ? '取消收藏' : '添加收藏',
      "placement": "top"
    }
  }, [_c('span', {
    class: ['icon-heart', {
      'icon-heart-shape': _vm.productVal.is_collected
    }]
  })]), _vm._v("\n                    " + _vm._s(_vm.productVal.fan_num) + "\n                ")], 1), _vm._v(" "), _c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.download(_vm.productVal.id)
      }
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "下载应用",
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "icon-download"
  })]), _vm._v("\n                    " + _vm._s(_vm.productVal.download_num) + "\n                ")], 1)], 1)]), _vm._v(" "), (_vm.productVal.pay_type === 3) ? _c('img', {
    staticClass: "inquiry",
    attrs: {
      "src": require("../../images/application_detail/inquiry.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "product-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.filterXSS(_vm.productVal.desc))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-footer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    attrs: {
      "height": "26",
      "src": _vm.productVal.user.avatar,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.goHomePage(_vm.productVal.user.id)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "current-version"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("当前版本 : ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.productVal.on_line_version.current_version || '--'))])]), _vm._v(" "), _c('div', {
    staticClass: "update-time"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("更新时间 : ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.productVal.on_line_version.update_time || '--'))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-60440572!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/product.vue
// module id = 1fYB
// module chunks = 15